import { useEffect } from "react";
import useForm from "../../hooks/useForm";
import RenderInput from "../../utils/RandarInput";

interface Field {
  id: string;
  [key: string]: any; // For other potential field properties
}

interface VitalFormProps {
  fields: Field[];
  formData: Record<string, any>;
  onFormUpdate: (formValues: Record<string, any>) => void;
  vitalFormErrors: Record<string, string>;
}

const VitalForm = ({ fields, formData, onFormUpdate, vitalFormErrors }: VitalFormProps) => {
  const { formValues, setFormValues, errors, setErrors } = useForm({
    ...formData,
  });

  useEffect(() => {
    onFormUpdate(formValues);
  }, [formValues]);

  useEffect(() => {
    setErrors(vitalFormErrors);
  }, []);

  useEffect(() => {
    setErrors(vitalFormErrors);
  }, [vitalFormErrors]);

  return (
    <div>
      {fields.map((field) => {
        return (
          <RenderInput
            item={{
              ...field,
              type: field.type ?? 'text',
              error: (errors as any)?.[field?.id] ? true : false,
              helperText: (errors as any)?.[field.id] || "",
            }}
            state={formValues}
            stateHandler={setFormValues}
            key={field?.id}
          />
        );
      })}
      <hr className="border-spacing-5" />
    </div>
  );
};

export default VitalForm;